export function loadFolderFiles (filesContext) {
  const modules = {}
  filesContext.keys().forEach((key) => {
    const fileName = key.replace(/(\.\/|\.js)/g, '')
    modules[fileName] = filesContext(key).default
  })
  return modules
}
